export const translations = {
	custom: {
		en: {
			translation: {
				ACCOUNT_DISABLED: "Your account has been disabled. If you think this is an error, contact eMed Support.",
				ANY_ADDITIONAL_COMMENTS: "Any additional comments?",
				CLICK_HERE: "Click Here",
				CONFIRM_SIGNUP_CODE_SENT:
					"To complete your account signup, a confirmation code has been sent to your email. Please check your email and enter that code on this page.",
				DIDNT_RECEIVE_VERIFICATION_EMAIL: "If you do not receive a verification email within a few minutes",
				EMED_TERMS_LABEL: "eMed Terms of Use",
				FEEDBACK: "Feedback",
				FORGOT_PASSWORD_CODE_SENT:
					"A verification code has been sent to your email. Please check your email and enter that code on this page.",
				INCORRECT_CREDENTIALS:
					"Error: The email or password entered do not match an eMed account. Please create an account using the link below.",
				INVALID_CREDENTIALS: "You must verify your email to continue signing in. Check your email for a link.",
				NO: "No",
				PASSWORD_ERROR_MESSAGE:
					"Your password must be a minimum of 8 characters, with at least 1 number, 1 uppercase letter, 1 lowercase letter and 1 special character.",
				PRIVACY_POLICY_LABEL: "Privacy policy",
				SELECT_DROPDOWN_LABEL: "Select an option...",
				THANK_YOU: "Thank You",
				TOS_AGREEMENT: "I understand and agree to the {{eMed Terms of Use}} and {{Privacy Policy}}. *",
				UNKNOWN_ERROR: "Unknown error. Please try again.",
				USER_ALREADY_EXISTS: "An account already exists with this email address.",
				USER_NOT_CONFIRMED: "You must verify your email to continue signing in. Check your email for a link.",
				YES: "Yes"
			}
		},
		es: {
			translation: {
				"ACCOUNT_DISABLED": "Your account has been disabled. If you think this is an error, contact eMed Support.",
				"ANY_ADDITIONAL_COMMENTS": "¿Tienes algún comentario?",
				"CANCEL": "Cancelar",
				"CLICK_HERE": "Haga clic aquí",
				"CONFIRM_SIGNUP_CODE_SENT":
					"Para completar el registro de su cuenta, se ha enviado un código de confirmación a su correo electrónico. Por favor revise su correo electrónico e ingrese ese código en esta página.",
				"DIDNT_RECEIVE_VERIFICATION_EMAIL": "Si no recibe un correo electrónico de verificación en unos minutos",
				"EMED_TERMS_LABEL": "Términos y condiciones",
				"FEEDBACK": "Comentarios",
				"FORGOT_PASSWORD_CODE_SENT":
					"Se ha enviado un código de verificación a su correo electrónico. Por favor revise su correo electrónico e ingrese ese código en esta página.",
				"INCORRECT_CREDENTIALS":
					"Error: el correo electrónico o la contraseña ingresada no coinciden con una cuenta de eMed. Por favor cree una cuenta usando el enlace de abajo.",
				"INVALID_CREDENTIALS": "El nombre de usuario o la contraseña son incorrectos.",
				"NO": "No",
				"PASSWORD_ERROR_MESSAGE":
					"Su contraseña debe tener un mínimo de 8 caracteres, con al menos 1 número, 1 letra mayúscula, 1 letra minúscula y 1 carácter especial.",
				"PRIVACY_POLICY_LABEL": "Política de privacidad",
				"SELECT_DROPDOWN_LABEL": "Selecciona una opción...",
				"SUBMIT": "Enviar",
				"THANK_YOU": "¡Gracias!",
				"TOS_AGREEMENT":
					"Entiendo y estoy de acuerdo con los {{EMED_TERMS_LABEL}} y {{PRIVACY_POLICY_LABEL}} de eMed. *",
				"UNKNOWN_ERROR": "Error desconocido. Vuelva a intentarlo",
				"USER_ALREADY_EXISTS": "Ya existe una cuenta con esta dirección de correo electrónico",
				"USER_NOT_CONFIRMED":
					"Debe verificar su correo electrónico para continuar iniciando sesión. Busque un enlace en su correo electrónico",
				"YES": "Sí",
				"Invalid verification code provided, please try again":
					"Se proporcionó un código de verificación inválido, inténtelo de nuevo"
			}
		}
	}
	//     es: {
	//         translation: {
	//             "INCORRECT_CREDENTIALS": "",
	//             "PASSWORD_ERROR_MESSAGE": "Su contraseña debe tener un mínimo de 8 caracteres, con al menos 1 número, 1 letra mayúscula, 1 letra minúscula y 1 carácter especial.",
	//             "Email Address *": "Dirección de correo electrónico *",
	//             "Password *": "Contraseña *",
	//             "Enter your email address": "Ingresa tu dirección de correo electrónico",
	//             "Enter your password": "Ingresa tu contraseña",
	//             "Create a new account": "Crear una cuenta nueva",
	//             "Have an account?": "¿Tienes una cuenta? ",
	//             "Create account": "Crear una cuenta",
	//             "No account?": "¿No tienes cuenta? ",
	//             "Forgot your password?": "¿Olvidaste tu contraseña? ",

	//             "Sign In": "Iniciar sesión",

	//             "Select one...": "Selecciona una opción...",

	//         }
	//     }
};
